<template>
  <div>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>

    <v-data-table
      :search="search"
      :headers="dynamicHeaders"
      :items="dynamicRowsDetail"
      sort-by="calories"
      class="elevation-1"
      :loading="dynamicRowsDetail.length == 0"
      loading-text="Loading Data... Please wait"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon
          v-if="item.action.view == 'show'"
          small
          class="mr-3"
          @click="viewItem(item.rowId)"
          >mdi-eye
        </v-icon>
        <v-icon
          v-if="item.action.edit == 'show'"
          small
          class="mr-3"
          @click="editItem(item.rowId)"
          >mdi-pencil
        </v-icon>
        <v-icon
          v-if="item.action.delete == 'show'"
          small
          @click="deleteItem(item.rowId)"
          class="mr-3"
        >
          mdi-delete
        </v-icon>
        <v-icon
          v-if="item.action.analytics == 'show'"
          small
          @click="viewAnalytics(item.rowId)"
          class="mr-3"
        >
          mdi-google-analytics
        </v-icon>
        <v-icon
          v-if="item.action.redeem == 'show'"
          small
          @click="redeemItem(item.rowId)"
          class="mr-3"
        >
          mdi-wallet-giftcard
        </v-icon>
      </template>
      <template v-slot:no-data> No Data Available </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    dynamicHeaders: Array, // headers of table
    dynamicRowsDetail: Array, // rows detail array containing (number of popups) array elements with format:
    // [ rowId: _ , nonAction: { elements corresponds to header information }, action: {} ]
  },
  data() {
    return {
      search: "",
    };
  },
  methods: {
    viewItem(id) {
      this.$emit("view-item", id);
    },
    editItem(id) {
      this.$emit("edit-item", id);
    },
    deleteItem(id) {
      this.$emit("delete-item", id);
    },
    viewAnalytics(id) {
      this.$emit("view-item-analytics", id);
    },
    redeemItem(id) {
      this.$emit("redeem-item", id);
    },
  },
};
</script>